import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';

import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';
import Loading from 'shared/portfolio/components/loading';
import {getInitialUserInfo, getUserInfo} from 'shared/portfolio/actions/portfolio';
import {useMediaQuery} from 'src/hooks/useMediaQuery';
import {getCourseList} from 'src/redux/lists';
import {UserType} from 'src/types/enums';
import {Store} from 'src/types/store';

import OnTrack from 'high-school-student/on-track/containers/on-track';
import HighSchoolAboutMe from 'src/views/high-school/about-me';
import TransferAboutMe from 'src/views/transfer/AboutMe';
import CCChecklist from '../getting-started/cc-checklist';
import HSChecklist from '../getting-started/hs-checklist';
import PortfolioItems from './portfolio-items';

const Portfolio = () => {
  const dispatch = useDispatch();
  const transfer = useSelector((state: Store) => state.transfer);
  const userType = useSelector((state: Store) => state.userType);
  const student = useSelector((state: Store) => state.student);
  const loading = useSelector((state: Store) => state.loading);
  const mq = useMediaQuery();
  const history = useHistory();
  const location = useLocation();
  const [showChecklist, setShowChecklist] = useState(true);
  const [scrollTo, setScrollTo] = useState(false);

  useEffect(() => {
    dispatch(setNavigationAnnouncement('Portfolio'));

    const educationPhase =
      userType === UserType.HS_STUDENT ? UserType.HS_STUDENT : UserType.CC_STUDENT;

    dispatch(getInitialUserInfo()).then(() => {
      dispatch(getUserInfo(educationPhase));
    });

    dispatch(getCourseList(educationPhase));
  }, [dispatch, userType]);

  useEffect(() => {
    // Navigate to portfolio section if present in URL
    // i.e. www.raise.me/portfolio#multimedia
    const section = location.hash;

    if (!loading && section && !scrollTo) {
      setScrollTo(true);
      scrollToSection(section.slice(1));
    }
  }, [loading, location.hash, scrollTo]);

  const scrollToSection = (divId: string) => {
    const sectionId = document.getElementById(divId);

    if (sectionId) {
      sectionId.scrollIntoView({behavior: 'smooth'});
    }
  };

  const navigateToCollegeSearch = () => history.push('/colleges/search');
  const hideChecklist = () => setShowChecklist(false);

  let senior = false;

  if (loading) {
    return <Loading />;
  } else {
    let colBar: React.ReactNode = null;
    senior = student.highSchoolInfo?.senior;

    if (!mq.SM_AND_UP) {
      colBar = <div>{!transfer && <OnTrack />}</div>;
    }

    return (
      <>
        {transfer ? <TransferAboutMe /> : <HighSchoolAboutMe />}
        <>
          <div>{colBar}</div>
          <div>
            {showChecklist && userType === UserType.HS_STUDENT && (
              <HSChecklist
                onDismiss={hideChecklist}
                navigateToCollegeSearch={navigateToCollegeSearch}
              />
            )}
            {showChecklist && userType === UserType.CC_STUDENT && (
              <CCChecklist
                onDismiss={hideChecklist}
                navigateToCollegeSearch={navigateToCollegeSearch}
              />
            )}
            <PortfolioItems {...{mq, transfer, senior}} />
          </div>
        </>
      </>
    );
  }
};

export default Portfolio;
